// Shared native-vs-external platform helpers. Mirrors `Event.derive_external_platform`
// on the backend so the modal, form, and public CTA label linked pages consistently.

export const EXTERNAL_PLATFORM_NAMES: Record<string, string> = {
  givebutter: 'Givebutter',
  classy: 'Classy',
  eventbrite: 'Eventbrite',
  givergy: 'Givergy',
}

export const EXTERNAL_PLATFORM_DOMAINS = {
  givebutter: ['givebutter.com'],
  classy: ['classy.org'],
  eventbrite: [
    'eventbrite.com',
    'eventbrite.co.uk',
    'eventbrite.ca',
    'eventbrite.com.au',
    'eventbrite.de',
    'eventbrite.fr',
    'eventbrite.ie',
  ],
  givergy: ['givergy.com'],
} as const

export function deriveExternalPlatform(url: string): string | null {
  const trimmed = url.trim()
  if (!trimmed) return null

  let host: string
  try {
    host = new URL(trimmed).hostname.toLowerCase().replace(/\.$/, '')
  } catch {
    return null
  }

  return Object.entries(EXTERNAL_PLATFORM_DOMAINS).find(([, domains]) => (
    domains.some((domain) => host === domain || host.endsWith(`.${domain}`))
  ))?.[0] ?? null
}

export function externalPlatformName(platform: string | null | undefined): string | null {
  return platform ? EXTERNAL_PLATFORM_NAMES[platform] ?? null : null
}
